export class ExternalAuth {

  constructor(
    public keycloakUrl: string,
    public entityDescriptor: string,
  ) {  }

}